const config = {
  name: "london",
  features: {
    accessCodes: false,
    moreInformation: true,
    hasParkingInstructions: true,
    hasPromoCodeWarning: false,
    displayPromoTotalUses: false, // Display "Redemptions left" on promo code card
    mandatoryFields: false,
    userPhoneNumber: false,
    userName: false,
    showAdaSupport: false,
    userPostalCode: false
  },
  parkingSession: {
    // Until the start of the reservation (12 am)
    cancelDaysBefore: 0,
    cancelTime: "00:00",
    cancelTimeOptions: [],
    // Start time offset from midnight, i.e. 12 am
    startOffsetHrs: 0,
    // Start date offset from today (0 = today) = no the same day reservations
    startOffsetDate: 1,
    // End date offset from start time
    endOffsetDate: 2
  }
}
export default config
